import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const authService = inject(AuthService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        // Only redirect to login if this is NOT a public catalog endpoint
        if (!req.url.includes('/api/catalog/')) {
          // Unauthorized - token expired or invalid
          // Clear storage and redirect to login
          authService.logout().subscribe();
          router.navigate(['/login']);
        }
      }

      // Log error for debugging
      console.error('HTTP Error:', error);

      return throwError(() => error);
    })
  );
};
